import{useLocation as useLocation$1,useNavigate}from"react-router-dom";const useLocation=()=>{const location=useLocation$1(),navigate=useNavigate();return{pathname:location.pathname,navigate,search:location.search}};export{useLocation};
